import { PlusOutlined } from '@ant-design/icons';
import { useLazyQuery, useMutation } from '@apollo/client';

import { Button, Modal } from 'antd';
import { debounce } from 'lodash';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { ROUTES, TABS } from '@common/constants';
import CommonHeader from '@components/CommonHeader';

import history from '../../../historyData';

import BlogsTable from '../components/BlogsTable';
import OrganizationTab from '../components/OrganizationTab';
import { DELETE_BLOG } from '../graphql/Mutations';
import { BLOGS_LIST } from '../graphql/Queries';

const OrganizationBlogs = () => {
  const { orgId, orgMode } = useParams();
  const [paginationConfig, setPaginationConfig] = useState({
    skip: 1,
    limit: 10,
  });
  const [sortConfig, setSortConfig] = useState();
  const [isActiveFilter, setIsActiveFilter] = useState(null);
  const [filterVisible, setFilterVisible] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [currentBlogData, setCurrentBlogData] = useState(null);
  const [search, setSearch] = useState('');

  const [
    blogList,
    { data: blogsData, loading: dataLoading, refetch: refetchBlogs },
  ] = useLazyQuery(BLOGS_LIST, {
    onError() {},
  });
  const [deleteBlog, { loading: deleteLoading }] = useMutation(DELETE_BLOG, {
    onError() {},
  });

  const getBlogs = async () => {
    const { skip, limit } = paginationConfig;
    try {
      await blogList({
        variables: {
          filter: {
            companyId: orgId,
            skip: (skip - 1) * limit,
            limit,
            search,
          },
          ...(sortConfig?.sortOn && {
            sort: sortConfig?.sortOn ? { ...sortConfig } : [],
          }),
        },
        fetchPolicy: 'network-only',
      });
    } catch (error) {
      return error;
    }
  };

  useEffect(() => {
    getBlogs();
  }, [paginationConfig, sortConfig, search]);

  const handleFilterApply = () => {
    getBlogs();
    setFilterVisible(false);
  };

  useEffect(() => {
    if (isActiveFilter === null) {
      handleFilterApply();
    }
  }, [isActiveFilter]);

  const handleTableChange = (pagination, _filters, sorter) => {
    setPaginationConfig({
      skip: pagination?.current,
      limit: pagination?.pageSize,
    });
    setSortConfig({
      sortOn: sorter?.order ? sorter?.field : '',
      sortBy: sorter?.order === 'descend' ? 'DESC' : 'ASC',
    });
  };
  const handleDeleteModalOpen = (value, type) => {
    setIsDeleteOpen(true);
    setCurrentBlogData({ ...value, type });
  };
  const handleDeleteRoofType = async (id) => {
    try {
      const res = await deleteBlog({ variables: { where: { id } } });
      if (res?.data) {
        setCurrentBlogData(null);
        setIsDeleteOpen(false);
        getBlogs();
      }
    } catch (error) {
      return error;
    }
  };
  const baseRoute = `${ROUTES?.ORGANIZATIONS}/${orgMode}/${orgId}/${TABS?.BLOGS?.key}`;

  const onSearchChange = debounce((e) => {
    const { value } = e?.target;
    setPaginationConfig({ ...paginationConfig, skip: 1 });
    setSearch(value);
  }, 600);

  const renderHeaderRightContent = () => (
    <Button
      className="common-button"
      size="middle"
      icon={<PlusOutlined />}
      onClick={() => history?.push(`${baseRoute}/add`)}
    >
      Add Blog
    </Button>
  );

  return (
    <>
      <CommonHeader heading="Blogs" customLink={ROUTES?.ORGANIZATIONS}>
        {renderHeaderRightContent()}
      </CommonHeader>
      <OrganizationTab>
        <BlogsTable
          baseRoute={baseRoute}
          handleTableChange={handleTableChange}
          paginationConfig={paginationConfig}
          sortConfig={sortConfig}
          blogsData={blogsData?.blogs}
          loading={dataLoading}
          onSearchChange={onSearchChange}
          handleDeleteModalOpen={handleDeleteModalOpen}
          isActiveFilter={isActiveFilter}
          setIsActiveFilter={setIsActiveFilter}
          handleFilterApply={handleFilterApply}
          filterVisible={filterVisible}
          setFilterVisible={setFilterVisible}
          refetchBlogs={refetchBlogs}
        />
      </OrganizationTab>
      <Modal
        title="Delete the Blog"
        okText="Yes"
        cancelText="No"
        open={isDeleteOpen}
        onOk={() => handleDeleteRoofType(currentBlogData?.id)}
        okButtonProps={{ loading: deleteLoading }}
        onCancel={() => {
          setIsDeleteOpen(false);
          setCurrentBlogData(null);
        }}
      >
        Are you sure you want to delete this blog?
      </Modal>
    </>
  );
};

export default OrganizationBlogs;
